import axios from "axios";

export const API = "/api";

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(error) {
  const detail = error?.response?.data?.detail;
  if (detail == null) return error?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
